import dynamic from 'next/dynamic';
import { NextSeo } from 'next-seo';
import PageFooter from '@/common/PageFooter';
import PageHeader from '@/common/PageHeader';
import Links from '@/sitemap/Links';
import { absoluteBaseUrl, isTest } from '~/constants/environment';
import { sitePageProject, sitePageTrack } from '~/constants/eventable';
import AnalyticsProvider from '~/context/common/AnalyticsProvider';

const FeatureBranch = dynamic(
  () =>
    import(/* webpackChunkName: "FeatureBranch" */ '@/common/FeatureBranch'),
  { ssr: false }
);

export default function SiteMap() {
  return (
    <>
      <NextSeo
        title="Sitemap | Carvana"
        description="Carvana sitemap"
        canonical={`${absoluteBaseUrl}/sitemap`}
      />

      {isTest && <FeatureBranch />}

      <PageHeader pathname="/sitemap" />

      <AnalyticsProvider projectName={sitePageProject} track={sitePageTrack}>
        <main className="grid gap-2xl bg-white px-4xl py-xl">
          <h1 className="tl-header-xl">Site Map</h1>

          <Links />
        </main>
      </AnalyticsProvider>

      <PageFooter className="bg-white" />
    </>
  );
}
